export default {
    name: "aside",
    init() {
        let asideMenu = document.querySelector(".js-my-account-aside");
        let toggle = document.querySelector(".js-my-account-menu-toggle");
        let nav = document.querySelector(".js-my-account-nav");

        if(!toggle || !asideMenu){
            return;
        }
        
        toggle.addEventListener("click", (e) => {
            asideMenu.classList.toggle("active");
            toggle.classList.toggle("active");
            if (asideMenu.classList.contains("active")) {
                document.cookie = "asideMenu=active";
            } else {
                document.cookie = "asideMenu=";
            }
        });
    },
};
